import EntityBaseRepository from '@/api/misc/EntityBaseRepository';
import { AxiosResponse } from 'axios';

export interface RatingModerationFilters {
    page?: number,
    pageSize?: number,
    rate?: number,
    moderationStatus?: string,
    withCommentOnly?: boolean,
    driver?: string,
    from?: string,
    to?: string
}

/**
 * Repository for the admin rating-moderation endpoints (backend `rating` service).
 *
 * All of these are checkManager-guarded server-side; the UI additionally only
 * surfaces them on the admin-only moderation view.
 */
export default class RatingRepository extends EntityBaseRepository {
    public moderationList(filters: RatingModerationFilters = {}): Promise<AxiosResponse> {
        const params = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });
        const query = params.toString();
        return this.axiosClient.get(`rating/moderation${query ? `?${query}` : ''}`);
    }

    /** Suppresses the comment only; the rate keeps counting toward avgRating. */
    public hide(payload: { id: string, reason: string }): Promise<AxiosResponse> {
        return this.axiosClient.post(`rating/${payload.id}/hide`, { reason: payload.reason });
    }

    /** Retracts the whole rating; the rate stops counting. Soft, reversible via restore. */
    public moderationDelete(payload: { id: string, reason: string }): Promise<AxiosResponse> {
        return this.axiosClient.post(`rating/${payload.id}/delete`, { reason: payload.reason });
    }

    public restore(payload: { id: string, reason: string }): Promise<AxiosResponse> {
        return this.axiosClient.post(`rating/${payload.id}/restore`, { reason: payload.reason });
    }
}
